<div class="spinner-container"> {{inputData.text}} <div class="spinner">
    <div class="spinner-line"></div>
    <div class="spinner-line"></div>
    <div class="spinner-line"></div>
    <div class="spinner-line"></div>
<!-- </div> Some text after the spinner </div> -->